




















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    JS Module
---------------------------------------- */

import { Related } from '@js/module/Related';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    props: {
        related: Array
    },

    mounted() {
        // new Related();
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class RelatedPages extends Vue {}

